const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/global/waysToCode`;

const waysToCode = {
  title: 'Three paths to proven results',
  backgroundColor: '#FFFFFF',
  ctaLabel: 'Start 7-Day FREE Trial',
  ways: [
    {
      title: 'Master coding basics with puzzles',
      text:
        'In the puzzles section, kid-coders learn core concepts and master the coding interface with scaffolded lessons that quickly strengthen foundational understanding.',
      image: `${imgURL}/learn_with_puzzles.png`,
    },
    {
      title: 'Explore challenges to level up skills',
      text:
        'Kid-coders expand their knowledge through interactive challenges, drilling down into advanced computer science concepts to build their problem-solving and logic skills.',
      image: `${imgURL}/explore_mini_games.png`,
    },
    {
      title: 'Create original games & stories',
      text:
        'Kid-coders gain new skills by crafting their own games and stories through self-guided experimentation and play, applying knowledge transferred from Puzzles and Explore.',
      image: `${imgURL}/create_stories_and_games.png`,
    },
  ],
};

export const getVariantWaysToCodeData = variant => {
  return waysToCode;
};



// WEBPACK FOOTER //
// ./src/containers/Home/sections/WaysToCode/waysToCodeData.js